import ElementUI from 'element-ui';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';

import App from '@/App.vue';
import initPermission from '@/directive/permission/index';
import { setupI18n } from '@/language/index';
import router, { setupRouter } from '@/router';
import store from '@/store';
import { initHttpInterceptors } from '@/utils/http/index';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss';
import '@/assets/iconfont/iconfont.css';
import '@/assets/font/font.css';
import '@/componentsV2/base-cmps';

export const i18n = setupI18n();
initPermission(store);
setupRouter(i18n, store);
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });
Vue.use(VueClipboard);
Vue.config.productionTip = false;
initHttpInterceptors(store, router, i18n);
Vue.prototype.$bus = new Vue();
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
